import api from './config/api';

import { ReactText } from 'react';
import TPA, { ITPAResult } from 'models/Forms/TPA';

export const save = (data: TPA) =>
  api.post<TPA>('/lei-geral-protecao-de-dados/assessment-terceiros/tab/salvar', data);

export const readTPA = (id: ReactText) =>
  api.get<TPA>(`/lei-geral-protecao-de-dados/assessment-terceiros/${id}`);

export const result = (id: ReactText) =>
  api.get<ITPAResult>(`/lei-geral-protecao-de-dados/assessment-terceiros/completo/${id}`);

export const sendEmail = (id: ReactText) =>
  api.post(
    `/lei-geral-protecao-de-dados/assessment-terceiros/tab/conclusion`,
    {},
    {
      params: {
        id,
        finishWithLegalAssessment: true,
        sendBackWithComments: false,
      },
    },
  );
